export default __webpack_public_path__ + "static/media/item-1.92f5d240.webp";